import { toast } from 'react-toastify'

import { wretchClient } from '~in-app/lib/wretch/wretch'
import { ListingResponse } from '~in-app/types/api.dto'

import { ProductPrivilegeListQuery, ProductPrivileges } from './types'

export const fetchProductPrivilegeList = async (query: { query: ProductPrivilegeListQuery }) => {
  return wretchClient
    .url('/admin/1.0/products/privileges')
    .query(query.query)
    .get()
    .json<ListingResponse<ProductPrivileges>>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}

export const updateProductPrivilege = async (params?: { abortCtrl?: AbortController | AbortSignal, value?: any[] }) => {
  return wretchClient
    .url('/admin/1.0/products/privileges')
    .signal(params?.abortCtrl)
    .put(params?.value)
    .json<ProductPrivileges[]>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      throw err
    })
}

export const addProductPrivilege = async (params?: { abortCtrl?: AbortController | AbortSignal, value?: any[] }) => {
  return wretchClient
    .url('/admin/1.0/products/privileges')
    .signal(params?.abortCtrl)
    .post(params?.value)
    .json<ProductPrivileges[]>()
    .catch((err: any) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      throw err
    })
}

export const deleteProductPrivileges = async (params?: { abortCtrl?: AbortController | AbortSignal, ids?: string[] }) => {
  const idsPath = params?.ids?.join(',') || ''
  return wretchClient
    .url(`/admin/1.0/products/privileges/${idsPath}`)
    .signal(params?.abortCtrl)
    .delete()
    .res()
    .catch((err: any) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      throw err
    })
}
